import {
  FaEnvelopeOpenText,
  FaLocationArrow,
  FaMailBulk,
  FaPhoneAlt,
} from "@onemind-services-llc/react-icons-ng/fa";

export const CONTACT_FORM_CONSTANTS = { INDIA: "India" };

export const CONTACT_LIST = [
  {
    icon: FaEnvelopeOpenText,
    label: "sales@onemindservices.in",
    path: "mailto:sales@onemindservices.in",
  },
  {
    icon: FaMailBulk,
    label: "support@onemindservices.in",
    path: "mailto:support@onemindservices.in",
  },
  { icon: FaPhoneAlt, label: "+91 92173 62021", path: "tel:+919217362021" },
  {
    icon: FaLocationArrow,
    label:
      "8th Floor ,Magnum Towers-1, Sector 58, Golf Course Extension Road, Gurgaon, Haryana 122011",
    path: "https://maps.google.com?q=Magnum Towers, Sector 58, Golf Course Extension Road, Gurgaon, Haryana 122011",
    isExternal: true,
  },
];
